<template>
  <div>
    <div class="home" v-if="ss">
      <van-dialog v-model="app" title="检测">
        <div style="display: flex; margin-top: 5px">
          <div style="width: 33%">{{ zhenduan.cardState_0 }}</div>
          <div style="width: 33%">
            <div v-if="zhenduan.cardState_1 == -1">未知</div>
            <div v-if="zhenduan.cardState_1 == 0">正常</div>
            <div v-if="zhenduan.cardState_1 == 1">单项停机</div>
            <div v-if="zhenduan.cardState_1 == 2">停机</div>
            <div v-if="zhenduan.cardState_1 == 3">预销号</div>
            <div v-if="zhenduan.cardState_1 == 4">销号/拆机</div>
            <div v-if="zhenduan.cardState_1 == 5">过户</div>
            <div v-if="zhenduan.cardState_1 == 6">休眠</div>
            <div v-if="zhenduan.cardState_1 == 7">待激活</div>
            <div v-if="zhenduan.cardState_1 == 8">已停用</div>
            <div v-if="zhenduan.cardState_1 == 9">库存</div>
            <div v-if="zhenduan.cardState_1 == 10">已失效</div>
            <div v-if="zhenduan.cardState_1 == 11">违章停机</div>
            <div v-if="zhenduan.cardState_1 == 12">挂失</div>
            <div v-if="zhenduan.cardState_1 == 13">用户报停</div>
            <div v-if="zhenduan.cardState_1 == 14">不存在</div>
            <div v-if="zhenduan.cardState_1 == 15">低速</div>
            <div v-if="zhenduan.cardState_1 == 16">可测试</div>
          </div>
          <div
            :class="zhenduan.cardState_2 == '正常' ? 'grann' : 'red'"
            style="width: 33%"
          >
            {{ zhenduan.cardState_2 }}
          </div>
        </div>

        <div style="display: flex; margin-top: 5px">
          <div style="width: 33%">{{ zhenduan.cardSumFlow_0 }}</div>
          <div style="width: 33%">
            {{ zhenduan.cardSumFlow_1 }}
          </div>
          <div
            :class="zhenduan.cardSumFlow_2 == '正常' ? 'grann' : 'red'"
            style="width: 33%"
          >
            {{ zhenduan.cardSumFlow_2 }}
          </div>
        </div>

        <div style="display: flex; margin-top: 5px">
          <div style="width: 33%">{{ zhenduan.cardConsumeFlow_0 }}</div>
          <div style="width: 33%">
            {{ zhenduan.cardConsumeFlow_1 }}
          </div>
          <div
            :class="zhenduan.cardConsumeFlow_2 == '正常' ? 'grann' : 'red'"
            style="width: 33%"
          >
            {{ zhenduan.cardConsumeFlow_2 }}
          </div>
        </div>

        <div style="display: flex; margin-top: 5px">
          <div style="width: 33%">{{ zhenduan.cardSurplusFlow_0 }}</div>
          <div style="width: 33%">
            {{ zhenduan.cardSurplusFlow_1 }}
          </div>
          <div
            :class="zhenduan.cardSurplusFlow_2 == '正常' ? 'grann' : 'red'"
            style="width: 33%"
          >
            {{ zhenduan.cardSurplusFlow_2 }}
          </div>
        </div>
        <div style="display: flex; margin-top: 5px">
          <div style="width: 33%">{{ zhenduan.cardOfficialRealName_0 }}</div>
          <div style="width: 33%">
            {{ zhenduan.cardOfficialRealName_1 }}
          </div>
          <div
            :class="zhenduan.cardOfficialRealName_2 == '正常' ? 'grann' : 'red'"
            style="width: 33%"
          >
            {{ zhenduan.cardOfficialRealName_2 }}
          </div>
        </div>

        <div style="display: flex; margin-top: 5px">
          <div style="width: 33%">{{ zhenduan.cardEndTime_0 }}</div>
          <div style="width: 33%">
            {{ zhenduan.cardEndTime_1 }}
          </div>
          <div
            :class="zhenduan.cardEndTime_2 == '正常' ? 'grann' : 'red'"
            style="width: 33%"
          >
            {{ zhenduan.cardEndTime_2 }}
          </div>
        </div>
        <div style="display: flex; margin-top: 5px">
          <div style="width: 33%">{{ zhenduan.cardResult_0 }}</div>
          <div
            :class="zhenduan.cardResult_2 == '正常' ? 'grann' : 'red'"
            style="width: 66%; text-align: left; font-size: 15px"
          >
            {{ zhenduan.cardResult_1 }}
          </div>
        </div>
        <div style="display: flex; margin-top: 5px; margin-bottom: 10px">
          <div style="width: 33%"></div>
          <div
            @click="quick"
            style="
              width: 66%;
              text-align: left;
              font-size: 15px;
              color: #1890ff;
            "
          >
            {{
              zhenduan.cardResult_3 == 0
                ? "点击此处快速充值套餐"
                : zhenduan.cardResult_3 == 1
                ? "点击此处快速复机"
                : zhenduan.cardResult_3 == 2
                ? "点击此处快速实名"
                : ""
            }}
          </div>
        </div>
        <div
          style="display: flex; margin-top: 5px; margin-bottom: 20px"
          v-if="zhenduan.cardResult_2 == '正常'"
        >
          <div style="width: 33%"></div>
          <div
            @click="start"
            style="
              width: 66%;
              text-align: left;
              font-size: 15px;
              color: #1890ff;
            "
          >
            点击此处快速复机
          </div>
        </div>
      </van-dialog>
      <HelloWorld
        @real="real"
        :fom="form"
        @childFn="parentFn"
        :vv="vv"
        :url="realurl"
      />
      <div class="liuliang">
        <div style="display: flex; justify-content: space-between">
          <div style="display: flex">
            <img
              style="
                width: 16px;
                height: 16px;
                vertical-align: middle;
                margin-top: 3px;
              "
              src="../assets/1/监控.png"
            />
            <span style="margin-left: 5px; display: flex" class="zong">
              总流量
              <van-loading v-if="loding" color="#1989fa" size="20" />
              <span v-else class="zong" style="color: #009fff">
                {{
                  flowForm.sumFlowStr
                    ? flowForm.sumFlowStr
                    : Math.floor((flowForm.sumFlow / 1024) * 100) / 100 + "G"
                }}
              </span>
            </span>
          </div>
          <p
            class="zong"
            style="color: #009fff; text-align: right; margin-top: 0"
            @click="refresh"
          >
            更新流量
          </p>
        </div>
        <div>
          <van-progress
            style="z-index: 2"
            :percentage="flowForm.sumFlowStr ? 0 : this.cc"
            stroke-width="8"
          />
        </div>
        <div style="display: flex; justify-content: space-between">
          <div>
            <p class="zong" style="margin: 10px">已使用流量</p>
            <p class="zong">
              <span class="zong" v-if="loding" style="color: #009fff">
                {{ flowForm.consumeFlow }}G
              </span>
              <span class="zong" v-else style="color: #009fff">
                {{ Math.floor((flowForm.consumeFlow / 1024) * 100) / 100 }}G
              </span>
            </p>
          </div>
          <div>
            <p class="zong" style="margin: 10px">剩余流量</p>
            <p class="zong">
              <span class="zong" v-if="loding" style="color: #009fff">
                {{
                  flowForm.sumFlowStr
                    ? flowForm.sumFlowStr
                    : flowForm.surplusFlow + "G"
                }}
              </span>
              <span class="zong" v-else style="color: #009fff">
                {{
                  flowForm.sumFlowStr
                    ? flowForm.sumFlowStr
                    : Math.floor((flowForm.surplusFlow / 1024) * 100) / 100 +
                      "G"
                }}
              </span>
            </p>
          </div>
        </div>
        <div
          v-if="flowForm.maxEndTime"
          style="
            font-size: 14px;
            border-top: 1px solid #009fff;
            padding-top: 10px;
          "
        >
          到期时间:{{ flowForm.maxEndTime }}
        </div>
      </div>

      <div class="two">
        <div
          style="
            width: 50%;
            display: flex;
            align-items: center;
            border-right: 1px solid #e9e9e9;
            z-index: 9;
          "
          @click="iconClick(twoList[0])"
        >
          <img class="img" :src="twoList[0].imgUrl" alt="" />
          <div class="text">{{ twoList[0].name }}</div>
          <div class="jian">></div>
        </div>
        <div
          @click="iconClick(twoList[1])"
          style="
            display: flex;
            width: 50%;
            justify-content: center;
            align-items: center;
            margin-left: 16px;
            z-index: 9;
          "
        >
          <img class="img" :src="twoList[1].imgUrl" alt="" />
          <div class="text">{{ twoList[1].name }}</div>
          <div class="jian" style="margin-right: 0">></div>
        </div>
      </div>
      <div v-if="orderList.length > 0 && indexFlowSwitch == true">
        <div class="detail" v-for="item in orderList" :key="item.id">
          <div
            style="
              font-size: 18px;
              font-weight: 700;
              padding: 15px;
              display: flex;
              justify-content: space-between;
            "
          >
            <span
              style="
                text-align: start;
                width: 80%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              "
            >
              {{ item.mealName }}
            </span>
            <span style="color: #009fff" v-if="item.timeType == 1">生效中</span>
            <span style="color: green" v-if="item.timeType == 2">待生效</span>
            <span style="color: red" v-if="item.timeType == 3">已失效</span>
          </div>
          <div
            style="
              font-size: 15px;
              padding: 0 15px;
              display: flex;
              justify-content: space-between;
            "
          >
            <span
              style="
                text-align: start;
                width: 50%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              "
            >
              {{ item.mealType }}
            </span>
            <span>
              {{
                item.sumFlowStr
                  ? item.sumFlowStr
                  : item.imaginaryQuantity
                  ? Math.floor((item.imaginaryQuantity / 1024) * 100) / 100 +
                    "G"
                  : 0 + "G"
              }}
            </span>
          </div>
          <div
            style="
              font-size: 13px;
              padding: 15px;
              display: flex;
              justify-content: space-between;
            "
          >
            <span
              style="
                text-align: start;
                width: 50%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              "
            >
              开始：{{ item.addTime }}
            </span>
            <span
              style="
                text-align: right;
                width: 50%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              "
            >
              结束：{{ item.endTime }}
            </span>
          </div>
        </div>
      </div>
      <div class="liuliangs">
        <van-grid :border="false" :column-num="4">
          <van-grid-item
            v-for="item in otherList"
            :key="item.iconId"
            @click="iconClick(item)"
          >
            <img width="30" height="30" :src="item.imgUrl" />
            <span style="font-size: 14px">{{ item.name }}</span>
          </van-grid-item>
          <!-- <van-grid-item @click="iconClick(item)">
            <img width="30" height="30" src="../assets/xufei.png" />
            <span style="font-size: 14px">自动续费</span>
          </van-grid-item> -->
        </van-grid>
      </div>
      <van-popup
        style="width: 80%"
        round
        :close-on-click-overlay="false"
        v-model="showes"
        closeable
      >
        <div style="margin-top: 10px; font-size: 18px">实名登记</div>
        <div style="font-size: 15px; margin: 10px 0">
          {{
            fom.realNameCard
              ? "请复制卡号，然后点击实名"
              : "请使用这个卡号进行实名"
          }}
        </div>
        <div
          v-if="fom.realNameCard"
          style="
            margin: 5px 20px;
            border-radius: 10px;
            box-shadow: 0px 0px 10px rgba(128, 128, 128, 0.2);
          "
        >
          <input
            id="036"
            v-model="fom.realNameCard"
            readonly
            style="
              text-align: center;
              font-size: 17px;
              width: 75%;
              margin: 0 10px;
              border: 0;
            "
            type="text"
          />
          <span @click="copyse" style="color: #1890ff; font-size: 13px">
            复制
          </span>
        </div>
        <div
          style="
            border-radius: 10px;
            margin: 5px 20px;
            box-shadow: 0px 0px 10px rgba(128, 128, 128, 0.2);
          "
        >
          <input
            id="hao"
            v-model="fom.iccId"
            readonly
            style="
              text-align: center;
              font-size: 17px;
              width: 75%;
              margin: 0 10px;
              margin-top: 10px;
              border: 0;
            "
            type="text"
          />
          <span
            @click="copysec"
            v-if="fom.realNameCard"
            style="color: #1890ff; font-size: 13px"
          >
            复制
          </span>
        </div>

        <van-button
          v-if="fom.realNameCard"
          @click="copys"
          style="width: 85%; margin: 10px auto"
          round
          size="small"
          type="info"
        >
          实名
        </van-button>
        <van-button
          v-else
          @click="copys"
          style="width: 85%; margin: 10px auto"
          round
          size="small"
          type="info"
        >
          一键复制去实名
        </van-button>
      </van-popup>
      <div class="liuliangs">
        <div style="padding: 10px; display: flex">
          <van-image
            width="20"
            height="20"
            style="vertical-align: middle"
            :src="require('../assets/1/通告.png')"
          />
          <div
            class="zong"
            style="color: #009fff; font-size: 14px; margin-left: 10px"
          >
            温馨提示
          </div>
        </div>
        <van-action-sheet
          v-model="show"
          title="网络优选"
          style="background-color: #009fff; color: aliceblue"
        >
          <div class="content">
            <div style="text-align: left">
              <div>
                <div>
                  <span style="margin-right: 5px; width: 60%">
                    智能优选网络
                  </span>
                  <el-tag size="mini" type="danger" effect="dark">推荐</el-tag>

                  <div style="font-size: 15spx; color: darkgray">
                    根据三网信号状况，优选最佳网络
                  </div>
                </div>
                <span style="float: right; margin-top: -30px">
                  <el-radio v-model="radio" size="medium" label="三网通">
                    <br />
                  </el-radio>
                </span>
              </div>
            </div>
          </div>
          <div v-for="item in listS" :key="item.id" class="content">
            <div style="text-align: left">
              <span>{{ item.name }}</span>
              <el-radio
                style="float: right; margin-top: 2px"
                v-model="radio"
                size="medium"
                :label="item.name"
              >
                <br />
              </el-radio>
            </div>
          </div>
          <!-- <div class="content">
            <div style="text-align: left">
              <span>中国移动</span>
              <el-radio
                style="float: right; margin-top: 2px"
                v-model="radio"
                size="medium"
                label="中国移动"
              >
                <br />
              </el-radio>
            </div>
          </div>
          <div class="content">
            <div style="text-align: left">
              <span>中国电信</span>
              <el-radio
                style="float: right; margin-top: 2px"
                v-model="radio"
                size="medium"
                label="中国电信"
              >
                <br />
              </el-radio>
            </div>
          </div>
          <div class="content">
            <div style="text-align: left">
              <span>中国广电</span>
              <el-radio
                style="float: right; margin-top: 2px"
                v-model="radio"
                size="medium"
                label="中国广电"
              >
                <br />
              </el-radio>
            </div>
          </div> -->
          <div class="contents">
            <van-button style="width: 100%" @click="edit" round type="info">
              确认修改
            </van-button>
          </div>
        </van-action-sheet>
        <div
          style="
            padding: 10px;
            text-align: left;
            font-size: 14px;
            color: #009fff;
            border-top: 2px solid #009fff;
          "
        >
          <div style="margin: 10px 5px" v-for="item in arr" :key="item">
            {{ item }}
          </div>
        </div>
      </div>
      <div
        id="0368"
        style="
          text-align: center;
          color: transparent;
          width: 75%;
          margin: 10px auto;

          border: 0;
        "
      >
        {{ fom.realNameCard }}
      </div>
      <div
        id="hao2"
        style="
          text-align: center;
          color: transparent;
          width: 75%;
          margin: 10px auto;
          border: 0;
        "
      >
        {{ fom.iccId }}
      </div>
    </div>
    <!-- 首页弹窗 -->
    <van-dialog
      v-model="showAlert"
      @confirm="quren"
      style="overflow: auto"
      title="系统公告"
      :show-cancel-button="false"
    >
      <div
        class="titleas"
        v-html="nite.alert"
        @click="showImages($event)"
      ></div>
    </van-dialog>
    <!-- 优惠弹窗 -->
    <van-dialog
      v-if="fom.seriesCouponModel"
      v-model="Alert"
      confirmButtonText="继续参加优惠活动"
      cancelButtonText="放弃优惠原价订购"
      @confirm="abouts"
      @cancel="about"
      style="overflow: auto"
      show-cancel-button
    >
      <div
        class="titleas"
        v-html="fom.seriesCouponModel.couponTips"
        @click="showImages($event)"
      ></div>
    </van-dialog>
    <van-image-preview
      v-model="showImage"
      :images="[images]"
    ></van-image-preview>
    <Tab></Tab>
  </div>
</template>

<script>
  // @ is an alias to /src
  import { Loading } from "element-ui";
  import HelloWorld from "@/components/HelloWorld.vue";
  import Tab from "@/components/Tab.vue";
  import { realAddress, getThirdPartyUrl } from "@/api/user/index.js";
  import {
    phoneSimCard,
    updateFalseOp,
    refreshPhone,
    start,
    autoTestCard,
    getHide,
    getCardFlow,
    phoneSimCarda,
    phoneOrders,
  } from "../api/cardOperation";

  import { clientGet, getAll } from "../api/seting/index";
  //获取元素
  export default {
    name: "Home",

    data() {
      return {
        form: {},
        //流量管理
        flowForm: {
          sumFlow: "",
          consumeFlow: "- - - - ",
          surplusFlow: "- - - - ",
          maxEndTime: "",
        },
        //是否加载
        loding: true,
        Alert: false,
        showImage: false,
        images: "",
        showAlert: false,
        //图标前两个
        twoList: [],
        //其他图标
        otherList: [],
        zhenduan: {
          simCardModel: {
            state: 0,
          },
          state: 0,
          result: "",
        },
        equipmentUrl: "",
        app: false,
        fom: {
          seriesCouponModel: { couponTips: "" },
        },
        listS: [],
        three: [
          {
            id: 1,
            name: "中国移动",
          },
          {
            id: 2,
            name: "中国联通",
          },
          {
            id: 3,
            name: "中国电信",
          },
          {
            id: 5,
            name: "中国广电",
          },
        ],
        arr: [],
        ss: false,
        show: false,
        radio: 1,
        cc: 0,
        nite: {},
        vv: "",
        realurl: "",
        kefuurl: "",
        mallUrl: "",
        upUrl: "",
        showss: false,
        showes: false,
        isLoading: false,
        tubiao: [],
        flags: false, //控制使用
        x: "",
        y: "",
        mk: "",
        orderList: [],
        indexFlowSwitch: false,
        keUrl: "",
      };
    },
    created() {},
    mounted() {
      var id = this.$route.query.card;
      // Loading.service();
      if (this.$route.query.card) {
        localStorage.removeItem("meCardNum");
        localStorage.setItem("meCardNum", this.$route.query.card);
      }

      this.url();
      this.phoneSimCard();
      this.getHide();
      this.phoneOrders();
      this.getAll();
    },

    methods: {
      //系统设置
      getAll() {
        getAll().then((res) => {
          if (res.status) {
            this.indexFlowSwitch = res.data.indexFlowSwitch;
          }
        });
      },
      phoneOrders() {
        phoneOrders().then((res) => {
          if (res.status) {
            res.data.forEach((item) => {
              // this.payTypeList.forEach((items) => {
              //   if (item.payType == items.payType) {
              //     item.payType = items.payName;
              //   }
              // });
              if (item.state !== 4) {
                item.timeType = this.isDateBetween(item.addTime, item.endTime);
                if (item.melaValidityType == 0) {
                  item.melaValidity = item.melaValidity + "天";
                } else if (item.melaValidityType == 1) {
                  item.melaValidity = item.melaValidity + "月";
                } else if (item.melaValidityType == 2) {
                  item.melaValidity = item.melaValidity + "年";
                }
                if (item.mealType == "0") {
                  item.mealType = "自然月套餐";
                } else if (item.mealType == "1") {
                  item.mealType = "月卡套餐";
                } else if (item.mealType == "2") {
                  item.mealType = "联通自然月套餐";
                } else if (item.mealType == "3") {
                  item.mealType = "联通月卡套餐";
                } else if (item.mealType == "4") {
                  item.mealType = "叠加包套餐";
                } else if (item.mealType == "5") {
                  item.mealType = "无限叠加套餐";
                } else if (item.mealType == "6") {
                  item.mealType = "基础套餐";
                }
              }
            });
            this.orderList.push(
              ...res.data.filter((item) => item.timeType === 2)
            );
          }
        });
      },
      getCardFlow() {
        //流量管理
        this.flowForm = {
          sumFlow: "",
          consumeFlow: "- - - - ",
          surplusFlow: "- - - - ",
          maxEndTime: "",
        };
        this.cc = 0;
        this.loding = true;
        this.axios
          .get(
            `/app/simCard/getCardFlow?card=${localStorage.getItem("meCardNum")}`
          )
          .then((res) => {
            if (res.data.code == 0) {
              if (res.data.data.sumFlow == 0) {
                this.cc = 0;
              } else if (res.data.data.surplusFlow < 0) {
                this.cc = 100;
              } else {
                if (res.data.data.consumeFlow / res.data.data.sumFlow > 100) {
                  this.cc = 100;
                } else {
                  this.cc = Math.floor(
                    (res.data.data.consumeFlow / res.data.data.sumFlow) * 100
                  );
                }
              }
              this.flowForm = res.data.data;
              this.loding = false;
            } else {
              this.flowForm = {
                sumFlow: this.fom.sumFlow,
                consumeFlow: this.fom.consumeFlow,
                surplusFlow: this.fom.surplusFlow,
                maxEndTime: this.fom.maxEndTime,
              };
              if (this.fom.sumFlow == 0) {
                this.cc = 0;
              } else if (this.fom.surplusFlow < 0) {
                this.cc = 100;
              } else {
                if (this.fom.consumeFlow / this.fom.sumFlow > 100) {
                  this.cc = 100;
                } else {
                  this.cc = Math.floor(
                    (this.fom.consumeFlow / this.fom.sumFlow) * 100
                  );
                }
              }
              this.loding = false;
            }
          });
      },

      about() {
        this.$router.push(`/about`);
      },
      abouts() {
        this.$router.push("/discount");
      },
      showImages(e) {
        if (e.target.tagName == "IMG") {
          this.images = e.target.src;
          this.showImage = true;
        }
      },
      stopTouchendPropagationAfterScroll() {
        var locked = false;

        window.addEventListener(
          "touchmove",
          function (ev) {
            locked ||
              ((locked = true),
              window.addEventListener(
                "touchend",
                stopTouchendPropagation,
                true
              ));
          },
          true
        );
        function stopTouchendPropagation(ev) {
          ev.stopPropagation();
          window.removeEventListener("touchend", stopTouchendPropagation, true);
          locked = false;
        }
      },
      copys() {
        if (this.fom.seriesModel.realNameType != 4) {
          if (this.fom.seriesModel.realNameAlert == 1) {
            if (this.fom.realNameCard) {
              let input = document.createElement("input");
              input.value = this.fom.realNameCard;
              input.id = "creatDoms";
              document.body.appendChild(input);
              input.select();
              document.execCommand("copy");
              document.body.removeChild(input);

              let inputs = document.createElement("input");
              inputs.value = this.fom.iccId;
              inputs.id = "creatDomsa";
              document.body.appendChild(inputs);
              inputs.select();
              document.execCommand("copy");
              document.body.removeChild(inputs);
              this.$toast("复制成功");
            } else {
              let input = document.createElement("input");
              input.value = this.fom.iccId;
              input.id = "creatDoms";
              document.body.appendChild(input);
              input.select();
              document.execCommand("copy");
              document.body.removeChild(input);
              this.$toast("复制成功");
            }
          } else {
            if (this.fom.realNameCard == undefined) {
              var e = document.getElementById("hao");
              e.select(); // 选择对象
              console.log(e.select());
              document.execCommand("Copy"); // 执行浏览器复制命令
              this.$toast("复制成功");
            }
          }
        }

        if (this.fom.seriesModel.realNameType == 2) {
          window.location.href = `https://ec.iot.10086.cn/authApi/service/wx/realnameH5/stepOne?channelId=RNFORWEB&iccid=${this.fom.iccId}&msisdn=${this.fom.realNameCard}`;
        } else if (this.fom.seriesModel.realNameType == 1) {
          console.log("s");
        } else if (this.fom.seriesModel.realNameType == 3) {
          console.log("s");
        } else if (this.fom.seriesModel.realNameType == 4) {
          const upUrlLoad = this.$toast.loading({
            message: "加载中...2",
            forbidClick: true,
            loadingType: "spinner",
            duration: 3000,
          });
          realAddress(localStorage.getItem("meCardNum"))
            .then((res) => {
              if (res.code == 0) {
                window.location.href = res.msg;
                upUrlLoad.clear();
              } else {
                this.$toast.fail(res.msg);
              }
            })
            .catch(() => {
              upUrlLoad.clear();
            });
        } else if (this.fom.seriesModel.realNameType == 5) {
          const upUrlLoad = this.$toast.loading({
            message: "加载中...1",
            forbidClick: true,
            loadingType: "spinner",
            duration: 0,
          });

          getThirdPartyUrl(localStorage.getItem("meCardNum"))
            .then((res) => {
              if (res.code == 0) {
                window.location.href = res.msg;
                upUrlLoad.clear();
              } else {
                this.$toast.fail(res.msg);
              }
            })
            .catch(() => {
              upUrlLoad.clear();
            });
        } else {
          var str = this.realurl.replace(/卡号/g, this.fom.iccId);
          window.location.href = str;
        }
      },
      copyse() {
        let input = document.createElement("input");
        input.value = this.fom.realNameCard;
        input.id = "creatDoms";
        document.body.appendChild(input);
        input.select();
        document.execCommand("copy");
        document.body.removeChild(input);
        this.$toast("复制成功");
        // window.location.href = this.realurl;
      },
      copysec() {
        let input = document.createElement("input");
        input.value = this.fom.iccId;
        input.id = "creatDoms";
        document.body.appendChild(input);
        input.select();
        document.execCommand("copy");
        document.body.removeChild(input);
        this.$toast("复制成功");
        // window.location.href = this.realurl;
      },
      parentFn(payload) {
        //负组件获取子组件的值
        this.showes = payload;
      },
      kefu() {
        window.location.href = this.kefuurl;
      },
      getHide() {
        this.twoList = [];
        this.otherList = [];
        getHide().then((res) => {
          if (res.status) {
            res.data.forEach((item, index) => {
              if (index < 2) {
                this.twoList.push(item);
              } else {
                this.otherList.push(item);
              }
            });
            this.tubiao = res.data;
          }
        });
      },
      //快捷操作
      quick() {
        if (this.zhenduan.cardResult_3 == 0) {
          this.taocan();
        } else if (this.zhenduan.cardResult_3 == 1) {
          this.start();
        } else if (this.zhenduan.cardResult_3 == 2) {
          this.real();
        }
      },

      iconClick(val) {
        if (val.iconId == 15) {
          this.out();
        } else if (val.iconId == 1) {
          this.taocan();
        } else if (val.iconId == 14) {
          this.posss();
        } else if (val.iconId == 12) {
          this.radio = this.form.falseOp;
          this.show = true;
        } else if (val.iconId == 11) {
          this.shangcheng();
        } else if (val.iconId == 10) {
          this.fuwu();
        } else if (val.iconId == 8) {
          this.real();
        } else if (val.iconId == 7) {
          this.register();
        } else if (val.iconId == 16) {
          window.location.href = this.equipmentUrl;
        } else if (val.iconId == 17) {
          window.location.href = this.upUrl;
        } else {
          this.$router.push(val.route);
        }
      },
      url() {
        clientGet().then((res) => {
          if (res.status) {
            if (res.data) {
              this.upUrl = res.data.upUrl;
              this.kefuurl = res.data.customerService;
              this.realurl = res.data.realName;
              this.mallUrl = res.data.mallUrl;
              this.equipmentUrl = res.data.equipmentUrl;
            }
          }
        });
      },
      qqss() {
        phoneSimCard().then((res) => {
          if (res.status) {
            this.nite = res.data.seriesModel;
            if (
              this.nite.alert == "<p><br></p>" ||
              this.nite.alert == "" ||
              this.nite.alert == null
            ) {
              console.log(this.nite.alert);
            } else {
              if (res.data.isChange == 1) {
                this.$dialog
                  .confirm({
                    message: `${res.data.alert}`,
                    confirmButtonText: "申请换卡",
                    cancelButtonText: "查询进度",
                    closeOnClickOverlay: false,
                  })
                  .then(() => {
                    this.$router.push({
                      name: "Address",
                      query: {
                        type: res.data.postAge,
                        id: this.fom.logoutClassifyTypeModel.id,
                      },
                    });
                  })
                  .catch(() => {
                    this.$router.push(`/success`);
                  });
              } else {
                this.showAlert = true;
              }
            }
          }
        });
      },
      //确认
      quren() {
        console.log("1111");
        localStorage.setItem("222", 1);
        if (this.fom.endRemind == true && localStorage.getItem("end") == null) {
          this.$dialog
            .alert({
              message:
                "检测到您的流量即将到期，请及时续费，否则将影响您的正常使用",
            })
            .then(() => {
              localStorage.setItem("end", 1);
            });
        }
      },
      posss() {
        var sse = this.$toast.loading({
          message: "智能检测中...",
          forbidClick: true,
          loadingType: "spinner",
          duration: 0,
        });
        autoTestCard(localStorage.getItem("meCardNum"))
          .then((res) => {
            if (res.status) {
              this.zhenduan = res.data;
              this.app = true;
              sse.clear();
            }
          })
          .catch(() => {
            sse.clear();
          });
        //     });
        // });
      },

      start() {
        var ssex = this.$toast.loading({
          message: "正在执行复机...",
          forbidClick: true,
          loadingType: "spinner",
          duration: 0,
        });
        start()
          .then((res) => {
            if (res.status) {
              ssex.clear();
              this.$toast(res.msg);
              autoTestCard(localStorage.getItem("meCardNum")).then((res) => {
                this.zhenduan = res.data;
              });
            }
          })
          .catch(() => {
            ssex.clear();
          });
        //     });
        // });
      },
      refresh() {
        const refreshs = this.$toast.loading({
          message: "更新流量中...",
          forbidClick: true,
          loadingType: "spinner",
          duration: 0,
        });
        refreshPhone()
          .then((res) => {
            if (res.status) {
              this.phoneSimCard();
              refreshs.clear();
              this.$toast(res.msg);
            }
          })
          .catch(() => {
            refreshs.clear();
          });
      },
      edit() {
        if (this.fom.falseOpMap) {
          this.fom.falseOpMap.forEach((item) => {
            if (item.name == this.radio && item.value == 0) {
              updateFalseOp(this.radio).then((res) => {
                if (res.status) {
                  console.log(res);
                  this.phoneSimCard();

                  this.show = false;
                  this.$dialog
                    .confirm({
                      message:
                        "切换运营商需要耐心等待2-5分钟,切换运营商完成后，建议重启设备",
                    })
                    .then(() => {
                      // on confirm
                    })
                    .catch(() => {
                      // on cancel
                    });
                }
              });
            } else if (item.name == this.radio && item.value !== 0) {
              this.$dialog
                .confirm({
                  message: "当前运营商尚未实名，请先实名后在切换",
                })
                .then(() => {
                  phoneSimCarda(item.meCardNum).then((res) => {
                    if (res.status) {
                      this.fom = res.data;
                      this.real();
                    }
                  });
                })
                .catch(() => {
                  // on cancel
                });
            }
          });
        } else {
          updateFalseOp(this.radio).then((res) => {
            if (res.status) {
              console.log(res);
              this.phoneSimCard();

              this.show = false;
              this.$dialog
                .confirm({
                  message:
                    "切换运营商需要耐心等待2-5分钟,切换运营商完成后，建议重启设备",
                })
                .then(() => {
                  // on confirm
                })
                .catch(() => {
                  // on cancel
                });
            }
          });
        }
      },
      phoneSimCard() {
        const upUrlLoad = this.$toast.loading({
          message: "加载中...",
          forbidClick: true,
          loadingType: "spinner",
          duration: 0,
        });
        phoneSimCard()
          .then((res) => {
            if (res.status) {
              this.listS = [];
              if (res.data.ordersModel) {
                if (res.data.ordersModel.operatorSwitch) {
                  res.data.ordersModel.operatorSwitch = JSON.parse(
                    res.data.ordersModel.operatorSwitch
                  );
                  res.data.ordersModel.operatorSwitch.forEach((item) => {
                    this.three.forEach((items) => {
                      if (items.id == item) {
                        this.listS.push(items);
                      }
                    });
                  });
                } else {
                  this.listS = this.three;
                }
              } else {
                if (res.data.seriesModel.operatorSwitch) {
                  res.data.seriesModel.operatorSwitch = JSON.parse(
                    res.data.seriesModel.operatorSwitch
                  );
                  res.data.seriesModel.operatorSwitch.forEach((item) => {
                    this.three.forEach((items) => {
                      if (items.id == item) {
                        this.listS.push(items);
                      }
                    });
                  });
                } else {
                  this.listS = this.three;
                }
              }

              console.log("kankan ", this.listS);
              this.fom = res.data;
              this.form = res.data;
              upUrlLoad.clear();
              this.radio = this.form.falseOp;
              console.log(this.fom);
              if (res.data.mnnouncementModel) {
                this.vv = res.data.mnnouncementModel.content;
              }
              this.nite = res.data.seriesModel;
              this.arr = this.nite.notice.split(/\n/g);

              if (
                this.nite.alert == "<p><br></p>" ||
                this.nite.alert == "" ||
                this.nite.alert == null
              ) {
                if (res.data.isChange == 1) {
                  console.log("换了卡");
                  this.$dialog
                    .confirm({
                      message: `${this.fom.alert}`,
                      confirmButtonText: "申请换卡",
                      cancelButtonText: "查询进度",
                      closeOnClickOverlay: false,
                    })
                    .then(() => {
                      this.$router.push({
                        name: "Address",
                        query: {
                          type: this.fom.postAge,
                          id: this.fom.logoutClassifyTypeModel.id,
                        },
                      });
                    })
                    .catch(() => {
                      this.$router.push(`/success`);
                    });
                } else if (
                  res.data.endRemind == true &&
                  localStorage.getItem("end") == null
                ) {
                  this.$dialog
                    .alert({
                      message:
                        "检测到您的流量即将到期，请及时续费，否则将影响您的正常使用",
                    })
                    .then(() => {
                      localStorage.setItem("end", 1);
                    });
                }
              } else {
                if (res.data.isChange == 1) {
                  console.log("换了卡");
                  this.$dialog
                    .confirm({
                      message: `${this.fom.alert}`,
                      confirmButtonText: "申请换卡",
                      cancelButtonText: "查询进度",
                      closeOnClickOverlay: false,
                    })
                    .then(() => {
                      this.$router.push({
                        name: "Address",
                        query: {
                          type: this.fom.postAge,
                          id: this.fom.logoutClassifyTypeModel.id,
                        },
                      });
                    })
                    .catch(() => {
                      this.$router.push(`/success`);
                    });
                } else if (
                  res.data.endRemind == true &&
                  localStorage.getItem("end") == null
                ) {
                  this.$dialog
                    .alert({
                      message:
                        "检测到您的流量即将到期，请及时续费，否则将影响您的正常使用",
                    })
                    .then(() => {
                      localStorage.setItem("end", 1);
                    });
                } else {
                  if (localStorage.getItem("222") != "1") {
                    this.showAlert = true;
                  }
                }
              }
              this.getCardFlow();
              // Loading.service().close();
              this.ss = true;
            }
          })
          .catch(() => {
            upUrlLoad.clear();
          });
      },
      out() {
        localStorage.removeItem("card");
        localStorage.setItem("card", localStorage.getItem("meCardNum"));
        localStorage.removeItem("meCardNum");
        localStorage.removeItem("222");
        this.$router.push("/");
      },
      taocan() {
        console.log(this.fom, "2");
        if (
          this.fom.seriesModel.realNameOrder == 1 &&
          this.fom.officialRealName !== 0
        ) {
          this.$toast("请先进行官方实名，再充值");
        } else {
          console.log(this.fom, "1");
          if (this.fom.seriesCouponModel) {
            console.log(this.fom, "3");
            this.Alert = true;
          } else {
            console.log(this.fom, "4");
            this.$router.push(`/about`);
          }
        }
      },
      qq() {
        this.$router.push(`/feedback`);
      },
      fuwu() {
        window.location.href = this.kefuurl;
      },
      shangcheng() {
        window.location.href = this.mallUrl;
      },
      real() {
        if (this.fom.seriesModel.realNameJudge == 0) {
          if (this.fom.seriesModel.realNameAlert == 1) {
            this.copys();
            console.log("1");
          } else {
            this.showes = true;
          }
        } else if (
          this.fom.seriesModel.realNameJudge == 1 &&
          this.fom.officialRealName != 0
        ) {
          if (this.fom.seriesModel.realNameAlert == 1) {
            this.copys();
            console.log("2");
          } else {
            this.showes = true;
          }
        } else if (
          this.fom.seriesModel.realNameJudge == 1 &&
          this.fom.officialRealName == 0
        ) {
          this.$toast.fail("该卡已官方实名，不允许再次操作官方实名");
        } else if (this.fom.seriesModel.realNameJudge == 2) {
          if (this.fom.isPay == true && this.fom.officialRealName != 0) {
            if (this.fom.seriesModel.realNameAlert == 1) {
              console.log("3");
              this.copys();
            } else {
              this.showes = true;
            }
          } else if (this.fom.isPay == false) {
            this.$toast.fail("该卡未充值，请充值后再进行官方实名");
          } else if (this.fom.isPay == true && this.fom.officialRealName == 0) {
            this.$toast.fail("该卡已官方实名，不允许再次操作官方实名");
          }
        } else if (this.fom.seriesModel.realNameJudge == 3) {
          if (
            this.fom.isPay == true &&
            this.fom.officialRealName != 0 &&
            this.fom.isTheMonth == true
          ) {
            if (this.fom.seriesModel.realNameAlert == 1) {
              console.log("4");
              this.copys();
            } else {
              this.showes = true;
            }
          } else if (this.fom.officialRealName == 0) {
            this.$toast.fail("该卡已官方实名，不允许再次操作官方实名");
          } else {
            this.$toast.fail("没有有效期订单，不允许官方实名");
          }
        } else if (this.fom.officialRealName == 0) {
          this.$toast.fail("该卡已官方实名，不允许再次操作官方实名");
        } else {
          this.$toast.fail("请联系管理员");
        }
      },

      APN() {
        this.$router.push(`/apn`);
      },
      banlance() {
        this.$router.push(`/recharge`);
      },
      order() {
        this.$router.push(`/order`);
      },
      change() {
        this.$router.push(`/change`);
      },
      problem() {
        this.$router.push(`/problem`);
      },
      register() {
        var that = this;
        if (that.fom.realnameModel) {
          this.$toast("该卡已实名，不允许重复操作");
        } else {
          that.$router.push({
            name: "Register",
            params: {
              type: that.nite.type,
            },
          });
        }
      },
      password() {
        this.$router.push(`/password`);
      },
      query() {
        this.$router.push(`/query`);
      },
      isDateBetween(startDate, endDate) {
        const currentDate = new Date();
        const startTimestamp = new Date(startDate).getTime();
        const endTimestamp = new Date(endDate).getTime();
        const currentTimestamp = currentDate.getTime();
        if (
          currentTimestamp >= startTimestamp &&
          currentTimestamp <= endTimestamp
        ) {
          return 1; //套餐生效中
        } else if (currentTimestamp < startTimestamp) {
          return 2; //套餐未生效
        } else if (currentTimestamp > endTimestamp) {
          return 3; //套餐已失效
        }
      },
    },

    components: {
      HelloWorld,
      Tab,
    },
  };
</script>
<style lang="scss">
  .titleas {
    max-height: 360px;
    overflow: auto;
    margin: 10px 10px;
    text-align: left;

    p {
      img {
        width: 100%;
      }
    }
  }

  .van-popup--center {
    top: 40% !important;
  }
</style>

<style scoped lang="scss">
  .floatball {
    color: white;
    height: 40px;
    width: 40px;
    text-align: center;
    line-height: 40px;
    font-size: 16px;
    padding: 5px;
    z-index: 990;
    position: fixed;
    bottom: 50px;
    right: 20px;
    border-radius: 50%;
    background-color: rgba(29, 157, 237, 0.8);
  }
  .detail {
    width: 100%;
    margin: 15px 0;
    border-radius: 10px;
    box-sizing: border-box;
    background-color: #ffff;
    border: 1px solid #c5e1ff;
  }
  .home {
    padding: 15px;
    box-sizing: border-box;
    margin-bottom: 60px;
  }

  .two {
    margin-top: 15px;
    display: flex;
    justify-content: space-between;
    background: #ffffff;
    padding: 16px;
    border-radius: 10px;
    border: 1px solid #c5e1ff;
    .img {
      width: 30px;
      height: 30px;
    }
    .text {
      margin: 0 10px;
      line-height: 30px;
      font-size: 14px;
      text-align: center;
    }
    .jian {
      margin-right: 16px;
      width: 25px;
      height: 25px;
      line-height: 25px;
      text-align: center;
      border-radius: 50%;
      font-size: 15px;
      background: #e9e9e9;
      color: #ffffff;
    }
  }

  .plm {
    position: fixed;
    top: 223px;
    right: 30px;
    z-index: 9999999;
  }

  .grann {
    color: green;
  }

  .red {
    color: red;
  }

  .pulse1 {
    position: absolute;
    width: 50px;
    height: 50px;
    left: 8px;
    top: 9px;
    border: 6px solid #1890ff;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    z-index: 7;
    opacity: 0;
    -webkit-animation: warn1 2s ease-out;
    -moz-animation: warn1 2s ease-out;
    animation: warn1 2s ease-out;
    -webkit-animation-iteration-count: infinite;
    -moz-animation-iteration-count: infinite;
    animation-iteration-count: infinite;
    box-shadow: 1px 1px 30px #1890ff;
  }

  .content {
    width: 100%;
    background-color: white;
    padding: 20px;
    color: black;
    font-weight: 600;
    font-size: 16px;
    box-sizing: border-box;
    border-bottom: 1px solid #1890ff;
  }

  .contents {
    width: 100%;
    background-color: white;
    padding: 10px;
    box-sizing: border-box;
  }

  .liuliang {
    margin-top: 15px;
    width: 100%;
    height: 100%;
    background: white;
    border-radius: 10px;
    padding: 10px;
    box-sizing: border-box;
    border: 1px solid #c5e1ff;

    .zong {
      font-size: 14px;
      margin-top: 0px;
    }
  }

  .liuliangs {
    width: 100%;
    width: 100%;
    height: 100%;
    margin-top: 15px;
    background: white;
    border-radius: 10px;
    padding: 10px;
    box-sizing: border-box;
    border: 1px solid #c5e1ff;

    .zong {
      font-size: 16px;
    }
  }
</style>
